//爱心社捐款
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' :data-val='item'></Choose>
			<SelectFilterTable v-if='item.Property.Control=="SelectFilterTable"' @data-val='item' :template-data='templateData.TemplateContent.Controls'
			 :val-index='5'></SelectFilterTable>
		</div>

		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import SelectFilterTable from '../components/SelectFilterTable.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		getAdministrativeProgressive,
	} from '@/api/approval'
	import {
		getDepartmentInfo,
		getDepartmentRelationByStructs
	} from '@/api/department'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			SelectFilterTable
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				isDisabled: false
			}
		},
		created() {
			initWxConfig(this);

			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
		},
		methods: { //方法


			getTemplate: function() {
				var departs = this.logInfo.fullName;
				var that = this;

				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + that.templateId,
					method: "get",
				}).then(async res => {
					var controls = res.data.Body;
					controls.TemplateContent.Controls.forEach((item) => {
						item.IsShow = true;
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}else if(item.Property.Title[0].Text == "流程条件"){
							if(departs.indexOf("住宅行政支持组")>-1){
								if(that.logInfo.PositionName.indexOf('行政助理')>-1||that.logInfo.PositionName=='行政主管'){
									item.Value = "1.2";
								}else if(that.logInfo.PositionName=='行政主任'){
									item.Value = "1.3";
								}
							}else if(departs.indexOf("后勤房友圈")>-1){
								if(that.logInfo.PositionName.indexOf('行政助理')>-1||that.logInfo.PositionName=='行政主管'){
									item.Value = "2.2";
								}else if(that.logInfo.PositionName=='房友圈总经理助理'){
									item.Value = "2.3";
								}
							}else if(departs.indexOf("后勤按揭部")>-1){
								if(that.logInfo.PositionName.indexOf('行政助理')>-1||that.logInfo.PositionName=='行政主管'){
									item.Value = "3.2";
								}else if(that.logInfo.PositionName=='行政主任'){
									item.Value = "3.3";
								}
							}else if(departs.indexOf("后勤工商铺商业运营中心")>-1){
								if(that.logInfo.PositionName.indexOf('行政助理')>-1||that.logInfo.PositionName=='行政主管'){
									item.Value = '4.2';
								}else if(that.logInfo.PositionName=='工商铺总经理助理'){
									item.Value = '4.3';
								}
							}
							if(item.Value == null || item.Value == ''){
								this.Message({
									message: "无权限申请",
									type: "error",
									duration: 3000,
								});
								that.isDisabled = true;
							}
						}else if (item.Property.Title[0].Text == "行政主任") {
							getDepartmentRelationByStructs(departs, "行政主任", false).then(res => {
								if (res.Body != null) {
									res.Body[0].Nodes.forEach((depData) => {
										if (depData.Items != null) {
											depData.Items.forEach((userData) => {
												if (userData.PositionName == "行政主任") {
													item.Values = [];
													var insertDat = [userData.EmpNo, userData.EmpName]
													item.Values.push(insertDat);
												}
											})
										}
									});
								} 
								if(item.Values == null||item.Values == '') {
									item.Values = [
										["SC24000029", "钟志斌"]
									]
								}
							console.log(item.Values)
							})
							item.IsShow = false;
						}
					})
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
				})
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				
			},
			tableOperation(val, type, datas) {
				if (type == 'compute') {
					return;
				}else if(type == 'selectChoose'){
					window.wx.invoke("selectEnterpriseContact", {
						"fromDepartmentId": -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
						"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
						"type": ["department", "user"], // 必填，选择限制类型，指定department、user中的一个或者多个
						"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
						"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					}, function(res) {
						if (res.err_msg == "selectEnterpriseContact:ok") {
							if (typeof res.result == 'string') {
								res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
							}
							var selectedDepartmentList = res.result.departmentList; // 已选的部门列表
					
							for (var i = 0; i < selectedDepartmentList.length; i++) {
								var department = selectedDepartmentList[i];
								datas.Values.push([department.id, department.name]); // 已选的单个部门ID
								datas.Value = department.name; // 已选的单个部门名称
							}
					
						}
					})
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit: async function() {
				var that = this;
				var IsReturn = false;


				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
						return;
					}
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
